import React, { useEffect, useMemo, useRef } from "react";
import { getActualPeriodDuration, getAllMatchPeriods, getPlayedGamesPeriods } from "../../../../../sports/rules.js";
import { Box, Typography, Select, MenuItem, FormControl, InputLabel, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import clsx from 'clsx';
import useStyles from '../../../../../../styles/global-mui.js';
import DsasButton from "../../../../../components/DsasButton/DsasButton.js";

const SelectPeriodTimer = ({ event, onChange, scale = 1, directEvent }) => {

  const minuteSelectionAnchorRef = useRef(null); 
  const scrollContainerRef = useRef(null); // ref conteneur scrollable
  

  // Mémorisation des périodes jouables
  const periodsToDisplay = useMemo(() => {
    const allPlayablePeriods = getPlayedGamesPeriods(directEvent.discipline);
    return Array.from(allPlayablePeriods.values()); // Convertit en tableau
  }, [directEvent.discipline]);

  // Mémorisation de la durée de la période
  const periodDuration = useMemo(() => {
    return getActualPeriodDuration(event.period, directEvent.discipline) + 40;
  }, [event.period, directEvent.discipline]);

  // const timeOffset = useMemo(() => {
  //     console.log('get time offset in SelectPeriodTimer')
  //   return getMinTotalDuration(event.period, directEvent.discipline)
  // }, [event.period, directEvent.discipline])

  //TODO utiliser celui de rules.js
      function getPeriodPlayedModel(discipline, matchPeriod) {
          const allPeriods = getPlayedGamesPeriods(discipline);
          const periodModel = [...allPeriods.values()]
              .find(p => p.matchPeriod === matchPeriod);
  
          return periodModel;
          }
  //TODO utiliser celui de rules.js
      function getPeriodModel(discipline, matchPeriod) {
          const allPeriods = getAllMatchPeriods(discipline);
          const periodModel = [...allPeriods.values()]
              .find(p => p.matchPeriod === matchPeriod);
  
          return periodModel;
          }

    // const timerBase = useMemo(() => {
    //   // On s’aligne sur la même logique que pour les stats / temps de jeu
    //   //ici il faut récupérer les periodes jouables et ensuite récupérer le minDuration de la periode actuelle
    //   let currentPeriod = getPeriodPlayedModel(directEvent.discipline, event.period);
    //   if (!currentPeriod){
    //       currentPeriod = getPeriodModel(directEvent.discipline, event.period);
    //       //TODO OPTA PER 2 - bout de scotch là
    //               if (!currentPeriod){
    //                   currentPeriod = getPeriodModel(directEvent.discipline, 6);
    //               }
    //   }
    //   const baseMinutes = currentPeriod?.maxDuration || 0;
    //   let delta = 0;
    //   //return delta or 0
    //   if (event.timer){
    //       delta = Math.round(event.timer / scale) - baseMinutes;
    //   }

    //   console.log('SelectPeriodTimer - get time offset', directEvent.discipline, event.period, currentPeriod, baseMinutes);
  
    //   // const baseMinutes = getMinTotalDuration(match.period, match.discipline);
    //   return delta;
    //   }, [event.period, directEvent.discipline]);

const timeOffset = useMemo(() => {
      // On s’aligne sur la même logique que pour les stats / temps de jeu
      //ici il faut récupérer les periodes jouables et ensuite récupérer le minDuration de la periode actuelle
      let currentPeriod = getPeriodPlayedModel(directEvent.discipline, event.period);
      if (!currentPeriod){
          currentPeriod = getPeriodModel(directEvent.discipline, event.period);
          //TODO OPTA PER 2 - bout de scotch là
                  if (!currentPeriod){
                      currentPeriod = getPeriodModel(directEvent.discipline, 6);
                  }
      }
      const baseMinutes = currentPeriod?.minDuration || 0;

      console.log('SelectPeriodTimer - get time offset', directEvent.discipline, event.period, currentPeriod, baseMinutes);
  
      // const baseMinutes = getMinTotalDuration(match.period, match.discipline);
      return baseMinutes;
      }, [event.period, directEvent.discipline]);
  
  const selectedMinute = Math.round((event.timer ?? 0) / scale) + timeOffset;

  useEffect(() => {
    if (!minuteSelectionAnchorRef.current || !scrollContainerRef.current) return;

    const container = scrollContainerRef.current;
    const element = minuteSelectionAnchorRef.current;

    // Position relative de l'élément par rapport au conteneur
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    // Calcul du scrollTop à appliquer pour centrer l'élément
    const offset = elementRect.top - containerRect.top;
    const scroll = offset - container.clientHeight / 2 + element.clientHeight / 2;

    container.scrollTo({
      top: scroll + container.scrollTop,
      behavior: 'smooth',
    });

  }, [selectedMinute]);

  const classes = useStyles();

  return (
    <Box>
      {/* Sélecteur de période */}
      {directEvent.type === 'match' && (
        <FormControl fullWidth size="small" sx={{ mb: 2 }} className={classes.customInput}>
          <InputLabel>Période</InputLabel>
          <Select
            value={event.period}
            label="Période"
            onChange={(e) => onChange("period", parseInt(e.target.value))}
          >
            {periodsToDisplay.map((p) => (
              <MenuItem key={p.matchPeriod} value={p.matchPeriod}>
                {p.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Liste scrollable de minutes */}
      {directEvent.type === 'match' && (
        <Box
          ref={scrollContainerRef}
          sx={{
            maxHeight: 180,
            overflowY: "auto",
            border: "1px solid #ddd",
            borderRadius: "6px",
            px: 1,
            py: 1,
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
            {Array.from({ length: periodDuration }, (_, i) => {
              const minute = i + timeOffset;
              return (
                <React.Fragment key={minute}>
                  {minute === selectedMinute && <div ref={minuteSelectionAnchorRef} />}
                  <DsasButton
                    customCss={{ width: '70%', maxWidth: '200px', minHeight: '35px'}} 
                    label={`${minute}′`} 
                    variant = 'alternative'
                    focused={minute === selectedMinute}
                    key={minute}
                    onClick={() => onChange("timer", scale * (minute - timeOffset))}
                  >
                  </DsasButton>
                </React.Fragment>
              );
            })}
          </Box>
        </Box>
      )}

      {/* DatePicker si aucun timer défini */}
      {/* {JSON.stringify(event.timer)} */}
      {!event.timer && (
        <Box className='centered-wrapper column-display'>
        <Box mt={2}>
          <Typography component="span" display="flex" alignItems="center" sx={{ paddingLeft: '2px' }} variant='body2' className={classes.customInputLabel}>
            Date et heure
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              value={event.displayDate ?? event.creation}
              onChange={(newDate) => onChange('displayDate', newDate)}
              inputFormat="dd/MM/yyyy HH:mm:ss"
              renderInput={(params) => <TextField {...params} className={clsx(classes.customInput, classes.customInputStandardSvg)} fullWidth sx={{ maxWidth: 250 }} />}
            />
          </LocalizationProvider>
        </Box>
        </Box>
      )}
    </Box>
  );
};

export default SelectPeriodTimer;
